module.exports = __webpack_public_path__ + "img/unplug_unwind.ecce750f.png";